import toast from 'react-hot-toast/headless';

interface UseToastResult {
  toast: (typeof toast)['custom'];
  dismiss: (typeof toast)['dismiss'];
}

export function useToast(): UseToastResult {
  return {
    toast(content, options) {
      return toast.custom(content, options);
    },
    dismiss(...params) {
      return toast.dismiss(...params);
    },
  };
}
